import { render } from "./FeaturesSaveButton.vue?vue&type=template&id=02c5ed13&ts=true"
import script from "./FeaturesSaveButton.vue?vue&type=script&lang=ts"
export * from "./FeaturesSaveButton.vue?vue&type=script&lang=ts"

import "./FeaturesSaveButton.vue?vue&type=style&index=0&id=02c5ed13&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__